import React from "react";

function WaterSensorWidget() {

  return (
    <div className={`widget`}>
      <div className="dashboard-widget-title">
        <h1 className="dashboard-widget-title-name">누수 감지 센서</h1>
        <p className="dashboard-widget-title-place">장소</p>
      </div>
      <div className="dashboard-widget-info">정상</div>
    </div>
  );
}

export default WaterSensorWidget;
